var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('JsonEditorVue',_vm._b({staticClass:"min-heigth-500",model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},'JsonEditorVue',_vm.jsonProperties,false))}
var staticRenderFns = []

export { render, staticRenderFns }